import { defineStore } from 'pinia'
import { ref } from 'vue'

// Define the type for the configuration object
interface RsConfig {
  // Add specific properties and their types here
  // For example: propertyName: string;
  [key: string]: any // Or a more specific type if known
}

export const useConfigStore = defineStore('config', () => {
  // State
  const rsConfig = ref<RsConfig>({})

  // Actions
  const setRsConfig = (config: RsConfig) => {
    rsConfig.value = config
  }

  return {
    rsConfig,
    setRsConfig
  }
})
